// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"AdminAwardsPage_toolbar__3i4AE","add":"AdminAwardsPage_add__2U45U","table":"AdminAwardsPage_table__3oHkh"};